import React from "react"
import './index.scss'

export const SocialMediaComponent = ({ socialMediaObj }) => {

  const filtered = socialMediaObj ? Object.keys(socialMediaObj).filter(key => (Array.isArray(socialMediaObj[key]) && !socialMediaObj[key][0]?.disabled)) : null;

  return (
    <div className="d-flex social-media-container justify-content-center">
      {filtered && filtered.map((item, index) => <div key={index.toString()}>
        {/*<div>{console.log('item', item)}</div>*/}
        {socialMediaObj[item][0]?.link?.url && <a className="px-2" href={socialMediaObj[item][0]?.link?.url} target="_blank">
          <img src={socialMediaObj[item][0]?.icon?.url}/>
        </a>}
      </div>)}
    </div>
  )
}
